export const environment = {
  production: true,
  apiBaseUrl: "",
  grafanaUrl: "https://opsviewersandbox.southcentralus.cloudapp.azure.com:3001"
};
